import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer>
      <p>&copy; 2026 Rudra Sports. All rights reserved.</p>
      <div className="footer-links">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" title="Facebook">
          <FaFacebook size="1.5em" />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" title="Instagram">
          <FaInstagram size="1.5em" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" title="Twitter">
          <FaTwitter size="1.5em" />
        </a>
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" title="LinkedIn">
          <FaLinkedin size="1.5em" />
        </a>
      </div>

    </footer>
  );
}
